import { useEffect, useSyncExternalStore } from 'react';
import { supabase } from '../utils/supabase';
import { applyPricing, pricingVersion, subscribePricing } from '../config/plans';

// Plan prices are edited in Admin → Payments → Prices and read here with the public get_pricing RPC.
// Until it answers (or if it fails) the defaults in src/config/plans.js are shown.
let loading = null;

export function loadPricing({ force = false } = {}) {
  if (!loading || force) {
    loading = supabase.rpc('get_pricing')
      .then(({ data, error }) => { if (!error && data) applyPricing(data); })
      .catch(() => { /* keep the defaults */ });
  }
  return loading;
}

/** Re-renders the component when the saved pricing arrives; call it in anything that shows a price. */
export function usePricing() {
  useEffect(() => { loadPricing(); }, []);
  return useSyncExternalStore(subscribePricing, pricingVersion);
}
